// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2REph","header":"MessagesList_header__41Du-","chat":"MessagesList_chat__7Zpll"};